import { getSticker } from "api-function/postContentApi";

import { AppLog } from "services";
import { AppRecordJK, AppRecordStatusJK, StatusMsg } from "utils";
import { create } from "zustand";
interface FetchStickersParams {
  packName?: string;
  searchText?: string;
  isRefresh?: boolean;
}
interface StickerState {
  stickers: Record<string, any[]>;
  stickerPacks: any[];
  appRecord: AppRecordJK;
  initializePage: () => Promise<void>;
  fetchStickers: (params?: FetchStickersParams) => Promise<void>;
}

export const stickerStore = create<StickerState>((set, get) => ({
  stickers: {},
  stickerPacks: [],
  appRecord: new AppRecordJK({ loadingStatus: AppRecordStatusJK.loaded }),
  initializePage: async () => {
    try {
      stickerStore.getState().fetchStickers({ isRefresh: true });
    } catch (error) {
      AppLog.show({
        message: `[initializePage]`,
        status: StatusMsg.error,
        error,
      });
    }
  },
  fetchStickers: async ({ packName = "", searchText = "", isRefresh = false }: FetchStickersParams = {}) => {
    const { stickers, appRecord, stickerPacks } = get();
    let tmpAppRecord = new AppRecordJK({ ...appRecord });
    try {
      if (isRefresh) {
        tmpAppRecord.loadingStatus = AppRecordStatusJK.loading;
        tmpAppRecord.nextPageUrl = "";
      } else {
        if (tmpAppRecord.canLoadMore()) {
          tmpAppRecord.loadingStatus = AppRecordStatusJK.loadingMore;
        } else {
          return;
        }
      }
      set({ appRecord: tmpAppRecord });
      const result = await getSticker({
        nextPageUrl: tmpAppRecord.nextPageUrl ?? "",
        searchText: searchText,
        pageName: packName,
      });
      if (result.status === StatusMsg.success.value) {
        const records = [...result["records"]["data"]];
        if (stickerPacks.length === 0) {
          set({
            stickerPacks: [{ name: "", id: "0" }, ...result["sticker_packs"]],
          });
        }
        const groupData = records.reduce((group: any, item) => {
          if (!group[item.pack_name]) {
            group[item.pack_name] = [];
          }
          group[item.pack_name].push(item);
          return group;
        }, {});

        if (result["records"]["next_page_url"] === null) {
          tmpAppRecord.nextPageUrl = "";
          tmpAppRecord.loadingStatus = AppRecordStatusJK.noLoadMore;
        } else {
          tmpAppRecord.nextPageUrl = result["records"]["next_page_url"];
          tmpAppRecord.loadingStatus = AppRecordStatusJK.loaded;
        }
        if (isRefresh) {
          set({
            stickers: groupData,
            appRecord: tmpAppRecord,
          });
        } else {
          const allStcikers = Object.keys(groupData).reduce((merged, packName) => {
            merged[packName] = [...(stickers[packName] || []), ...groupData[packName]];
            return merged;
          }, stickers);
          set({
            stickers: { ...allStcikers },
            appRecord: tmpAppRecord,
          });
        }
      } else {
        tmpAppRecord.loadingStatus = AppRecordStatusJK.loaded;
        set({
          appRecord: tmpAppRecord,
        });
        AppLog.show({
          message: `[fetchSticker] ${result["msg"]}`,
          status: StatusMsg.getType(result["status"]),
        });
      }
    } catch (error) {
      tmpAppRecord.loadingStatus = AppRecordStatusJK.loaded;
      set({ appRecord: tmpAppRecord });

      AppLog.show({
        message: `[fetchPosts]`,
        status: StatusMsg.error,
        error,
      });
    }
  },
}));
